module.exports = __webpack_public_path__ + "static/media/symbol_text_and_icon.vertex.903da801.glsl";